import React, { useEffect } from "react";
import banner from "../assets/images/mentorBanner.png";
import { Banner, GetStartedCard, WithLayout } from "../components";
// import sampleFin from "../../assets/images/sampleFinMentors.png";

export const SignIn = WithLayout(() => {
   useEffect(() => {
      window.location.href = "https://platform.knight.ventures/login";
   }, []);

   return (
      <div>
         <section>
            <Banner background={banner} mainText="Page Not Found" />
         </section>

         <section className="get-started-space">
            <GetStartedCard text="Join our program today!" />
         </section>
      </div>
   );
});
